// ============================================================================
// REPORT ENDPOINTS — Phase 1 skeleton
// ============================================================================
// Backend: ReportsController. Each report has POST /list and POST /summary.
// Drill engine is a single POST /booking-drill that pivots on `groupBy`.

import { buildEndpoint } from './base.endpoints';

const BASE_PATH = '/Reports';

const list    = (slug: string) => buildEndpoint(`${BASE_PATH}/${slug}`);
const summary = (slug: string) => buildEndpoint(`${BASE_PATH}/${slug}/summary`);

export const reportEndpoints = {
  bookingRegister:        { list: () => list('booking-register'),         summary: () => summary('booking-register'),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/booking-register/export`) },
  complimentary:          { list: () => list('complimentary'),            summary: () => summary('complimentary')            },
  discount:               { list: () => list('discount'),                 summary: () => summary('discount')                 },
  minRateViolation:       { list: () => list('min-rate-violation'),       summary: () => summary('min-rate-violation')       },
  mealPlanRevenue:        { list: () => list('meal-plan-revenue'),        summary: () => summary('meal-plan-revenue')        },
  extraPax:               { list: () => list('extra-pax'),                summary: () => summary('extra-pax')                },
  forwardOccupancy:       { list: () => list('forward-occupancy'),        summary: () => summary('forward-occupancy')        },
  agentCorporate:         { list: () => list('agent-corporate'),          summary: () => summary('agent-corporate')          },
  dailyMonthlySummary:    { list: () => list('daily-monthly-summary'),    summary: () => summary('daily-monthly-summary')    },
  occupancyChart:         { list: () => list('occupancy-chart'),          summary: () => summary('occupancy-chart'),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/occupancy-chart/export`) },
  checkinDetails:         { list: () => list('checkin-details'),          summary: () => summary('checkin-details')          },
  collection:             { list: () => list('collection'),               summary: () => summary('collection'),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/collection/export`) },
  // Guest Ledger — Posted vs Billed (PMS slice 6c): report, one day's lines, export.
  guestLedger:            { report: () => buildEndpoint(`${BASE_PATH}/guest-ledger`),
                            lines: () => buildEndpoint(`${BASE_PATH}/guest-ledger/lines`),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/guest-ledger/export`),
                            exportLines: () => buildEndpoint(`${BASE_PATH}/guest-ledger/lines/export`) },
  // Relaxations & Waivers (PMS slice 7c-2).
  waivers:                { report: () => buildEndpoint(`${BASE_PATH}/waivers`),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/waivers/export`) },
  // Checkout Register (BR-RPT-003..006).
  checkoutRegister:       { report: () => buildEndpoint(`${BASE_PATH}/checkout-register`),
                            exportFile: () => buildEndpoint(`${BASE_PATH}/checkout-register/export`) },
  drill:                  () => buildEndpoint(`${BASE_PATH}/booking-drill`),
};

export default reportEndpoints;
